import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import "rxjs/add/operator/map";
import "rxjs/add/operator/catch";

import {ResourceService} from "../../shared/comun/services/resource.service";
import {appService} from "../../credentials";

import {Funcionalidad} from "../models/funcionalidad.model";

@Injectable()
export class FuncionalidadService {

    constructor(private http: HttpClient,
                private resourceService: ResourceService) {
    }

    /**
     * @desc Obtiene en formato json la lista de funcionalidades
     * a la que tiene acceso el usuario logueado
     * @param {String} token
     * @returns {Observable<TResult>}
     */
    getFuncionalidadesAccesoUsuario(token) {
        let options = this.resourceService.getRequestOptions(token);
        return this.http.get<Funcionalidad[]>(appService.ws_seguridad_usuario_logueado_funcionalidades + appService.modulo_nombre, options)
    }
}
